import { captureMessage } from '@sentry/nextjs'

import { SupportedEvents, WebengageEventPayloadMap, WindowWithWebengage } from '../types'

declare const window: WindowWithWebengage

const lastEventTimestamps: Record<string, number> = {}

export const sendWebengageEvent = <T extends keyof WebengageEventPayloadMap>(
    event: T,
    data: WebengageEventPayloadMap[T]
) => {
    if (typeof window === 'undefined' || !window.webengage) return

    const now = Date.now()
    if (
        (event === SupportedEvents.homepage_view || event === SupportedEvents.page_view) &&
        lastEventTimestamps[event] &&
        now - lastEventTimestamps[event] < 2000
    ) {
        return
    }

    lastEventTimestamps[event] = now

    try {
        window.webengage.track(event, { ...data, date: new Date() })
    } catch (error) {
        const stringifiedError = JSON.stringify(error)
        captureMessage(stringifiedError)
    }
}
